<div class="auto-card">
  <span class="auto-card__badge">
    <i class="ph-fill ph-sparkle" aria-hidden="true"></i>
    {{ 'tenders.responses.documents.auto-selection.badge' | translate }}
  </span>
  <p class="auto-card__title">{{ 'tenders.responses.documents.auto-selection.title' | translate }}</p>
  <p class="auto-card__body">
    {{ 'tenders.responses.documents.auto-selection.body-before' | translate }}
    <button type="button" class="auto-card__link" (click)="goToLibrary.emit()">
      {{ 'tenders.responses.documents.auto-selection.body-link' | translate }}
    </button>
    {{ 'tenders.responses.documents.auto-selection.body-after' | translate }}
  </p>
</div>
